module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<div class=\"modal-body\">\n  <p>{{ message }}</p>\n</div>\n\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-outline-dark mr-auto ml-auto\" (click)=\"activeModal.dismiss('Button')\">Закрыть</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/error-modal.component.html
// module id = ./src/app/alert/error-modal.component.html
// module chunks = main